const load = () => {
  const options = {
    root: null, // The root element is null. It means to set the viewport.
    rootMargin: '100% 0px 0px 0px', // The observer fires when scrolling by viewport height.
    threshold: 0,
  };
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (!entry.isIntersecting && !document.body.classList.contains('is_toTopBtn_visible')) {
        document.body.classList.toggle('is_toTopBtn_visible');
      }

      if (entry.isIntersecting && document.body.classList.contains('is_toTopBtn_visible')) {
        document.body.classList.toggle('is_toTopBtn_visible');
      }
    });
  }, options)

  try {
    const target = document.getElementById('anchor:page-top')
    observer.observe(target)
  } catch (error) {
    console.log(error)
  }

}
export default load